import { render, staticRenderFns } from "./StudentsChatPanelBody.vue?vue&type=template&id=2345938c&scoped=true"
import script from "./StudentsChatPanelBody.vue?vue&type=script&lang=js"
export * from "./StudentsChatPanelBody.vue?vue&type=script&lang=js"
import style0 from "./StudentsChatPanelBody.vue?vue&type=style&index=0&id=2345938c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345938c",
  null
  
)

export default component.exports